export enum FilterEnum {
  ALL = 'ALL',
  PENDING = 'PENDING',
  PASSED = 'PASSED',
}
